import { ReportIdConst } from '../../enums/report.enum';

export const processParameters = (ReportID, formData, format = 'report') => {
  switch (ReportID) {
    case ReportIdConst.CADDataByMonth:
      return processCadDataByMonth(formData, format);
    default:
      return {};
  }
};
const processCadDataByMonth = (formData, format) => {
  if (!formData) return {};
  const newForm = {
    Year: formData?.year?.Code ?? new Date().getFullYear(),
    AgencyId: formData?.agency?.Code,
  };
  return newForm;
};

export const reportNameMapper = (id) => {
  switch (id) {
    case ReportIdConst.CADDataByMonth:
      return 'Cad Data By Month Report';
    default:
      return 'Report';
  }
};
